document.addEventListener("click", function (e) {
  const btn = e.target.closest("#LoadMoreButton");
  if (!btn) return;

  e.preventDefault();

  const nextUrl = btn.dataset.nextUrl;
  if (!nextUrl) return;

  const perPage = parseInt(btn.dataset.perPage || "0", 10);
  let shown = parseInt(btn.dataset.shown || "0", 10);
  const total = parseInt(btn.dataset.total || "0", 10);

  btn.disabled = true;
  const oldText = btn.textContent;
  btn.textContent = "LOADING...";

  fetch(nextUrl)
    .then((res) => res.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");

      // Dawn: product grid items
      const newItems = doc.querySelectorAll("#product-grid > li");
      const currentGrid = document.querySelector("#product-grid");

      if (currentGrid && newItems.length) {
        newItems.forEach((li) => currentGrid.appendChild(li));
      }

      // Update shown count
      if (perPage) shown = Math.min(shown + perPage, total);
      btn.dataset.shown = String(shown);

      const shownEl = document.querySelector("#LcShown");
      const totalEl = document.querySelector("#LcTotal");
      if (shownEl) shownEl.textContent = String(shown);
      if (totalEl) totalEl.textContent = String(total);

      // Update progress bar
      const wrap = document.querySelector(".lc-loadmore-wrap");
      if (wrap && total) {
        const pct = (shown / total) * 100;
        wrap.style.setProperty("--lc-progress", pct.toFixed(2) + "%");
      }

      // Update next button URL (avoid duplicates)
      const fetchedBtn = doc.querySelector("#LoadMoreButton");
      if (fetchedBtn && fetchedBtn.dataset.nextUrl) {
        btn.dataset.nextUrl = fetchedBtn.dataset.nextUrl;
        btn.disabled = false;
        btn.textContent = oldText;
      } else {
        btn.remove(); // no more pages
      }
    })
    .catch(() => {
      btn.disabled = false;
      btn.textContent = oldText;
    });
});